<template>
  <div class="resume-position-expect-wrap clearfix" v-if="pExpect">
    <ul class="list-info clearfix">
      <li v-if="pExpect.applyJobStatus">
        <span class="label">求职状态：</span>
        <p>{{pExpect.applyJobStatus | applyJobStatus}}</p>
      </li>
      <li v-if="(pExpect.currentSalary && pExpect.currentSalaryMonths) || pExpect.anualSalary || pExpect.salaryType">
        <span class="label">目前年薪：</span>
        <p>
          <span>{{pExpect.salaryType | salaryType}}</span>
          <span v-if="!(pExpect.currentSalary && pExpect.currentSalaryMonths)">{{pExpect.anualSalary}}元</span>
          <span v-if="pExpect.currentSalary && pExpect.currentSalaryMonths">
            {{(pExpect.currentSalary*pExpect.currentSalaryMonths) || 0 | tenThousand}}元
          </span>
          <span v-if="pExpect.currentSalary && pExpect.currentSalaryMonths">
            （{{pExpect.currentSalary || 0}}元/月 X {{pExpect.currentSalaryMonths || 0}}个月）
          </span>
        </p>
      </li>
      <li v-if="pExpect.otherWelfare">
        <span class="label">其他收入：</span>
        <p>{{pExpect.otherWelfare}}</p>
      </li>
      <li v-if="pExpect.expectIndustry">
        <span class="label">期望行业：</span>
        <p>{{pExpect.expectIndustry | industry}}</p>
      </li>
      <li v-if="pExpect.expectExtraPositionTitles">
          <span class="label">期望职位：</span>
          <p>{{pExpect.expectExtraPositionTitles}}</p>
        </li>
      <li v-if="pExpect.expectCity">
        <span class="label">期望城市：</span>
        <p>{{pExpect.expectCity | city}}</p>
      </li>
      <li v-if="pExpect.expectAnnualSalary">
        <span class="label">期望年薪：</span>
        <p>
          <span>{{pExpect.expectSalaryType | salaryType}}</span>
          <span>{{pExpect.expectAnnualSalary | tenThousand}}/年</span>
        </p>
      </li>
    </ul>
  </div>
</template>
<style scoped lang="scss">
.resume-position-expect-wrap {
  .list-info{
    line-height: 20px;
    padding-bottom: 5px;
    li{
      margin-bottom: 10px;
      font-size: 14px;
      float: left;
      width: 100%;
      .label{
        width: 70px;
        color: #666;
        display: block;
        float: left;
      }
      p{
        color: #151515;
        margin-left: 70px;
      }
    }
  }
}
</style>
<script>
export default {
  props:{
    pExpect: {}
  },
  data(){
    return{
      
    };
  },
  components: {
  },
  methods: {
  },
  created() {
  }
};
</script>
